import axios from '@util/axios';

class Reports {
  async getReports(
    assigneeId = null,
    assigneeRole = 'Employee',
    params = {},
    refresh = false
  ) {
    let url = `/assigned/report/${assigneeId}/${assigneeRole}`;

    if (refresh) url = '/reports/refresh/?refresh=True';

    return await axios({
      url: url,
      params: {
        page: params.page || null,
        page_size: params.page_size || null,
      },
    });
  }

  async assignReports(reportList, assigneeList, companyId = null) {
    let url = `/reports/assign/`;

    if (companyId) url = `/reports/assign/member/`;

    return await axios({
      url: url,
      method: 'POST',
      data: {
        report_list: reportList,
        [companyId ? 'member_list' : 'company_list']: assigneeList,
        ...(companyId ? { company_id: companyId } : null),
      },
    });
  }

  async unassignReport(id, assigneeType = 'Employee') {
    let url = `/reports/unassigned/${id}`;

    if ('Employee' === assigneeType) url = `/reports/unassigned/member/${id}`;

    return await axios({
      url: url,
      method: 'DELETE',
    });
  }
}

export default new Reports();
